/**
 * Formats a date value to local time string
 * @param {Object} data - Object containing the date value
 * @returns {string} Formatted date string
 */
export function adjustToLocalTime(data) {
  var formattedTime = data.value;
  if (!data.value || new Date(data.value).getYear() < 100) {
    return ``;
  }
  formattedTime = new Date(data.value).toLocaleString(`en-us`, {
    year: `2-digit`,
    month: `numeric`,
    day: `numeric`,
    hour: `numeric`,
    minute: `2-digit`,
  });

  return `${formattedTime}`;
}

/**
 * Formats a numeric value with dollar sign
 * @param {Object} data - Object containing the numeric value
 * @returns {string} Formatted currency string
 */
export function addDollarSign(data) {
  let formattedNum = data.value;
  if (isNaN(formattedNum)) {
    return data.value;
  }
  if (formattedNum < 0) {
    formattedNum = 0;
  }
  return `$${formattedNum.toFixed(2)}`;
}

/**
 * Formats a numeric value to string
 * @param {Object} data - Object containing the numeric value
 * @returns {string} Formatted numeric string
 */
export function numericFormat(data) {
  let formattedNum = data.value;
  if (isNaN(formattedNum)) {
    return data.value;
  }
  return `${formattedNum}`;
}

/**
 * Formats a date to YYYY-MM-DD format for API requests
 * @param {Date|string} date - Date to format
 * @returns {string|null} Formatted date string or null if invalid
 */
export function formatDateForAPI(date) {
  if (!date) return null;
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * Formats a percentage value with 2 decimal places
 * @param {Object} data - Object containing the percentage value
 * @param {number} data.value - The percentage value to format
 * @returns {string} Formatted percentage string (e.g., "45.67%")
 */
export function formatPercentage(data) {
  const value = data.value;
  if (value === undefined || value === null) return "0.00%";
  return `${value.toFixed(2)}%`;
}
